import React, { useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import "./ConfirmationModal.css";
import modalImage from "../../../../../assets/img/reel-section/confirmation/modal-image.png";
import { useGuest } from "../../../../../contexts/GuestContext";
import { SpinnerOverlay } from "../../../../spinner/SpinnerOverlay";

export const ConfirmationModal = () => {
  const { guest, confirmAttendance } = useGuest();
  const [selected, setSelected] = useState<number | null>(null);
  const [confirmed, setConfirmed] = useState(guest?.hasConfirmed);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (selected === null || !guest) return;
    setLoading(true);
    try {
      await confirmAttendance(selected);

      setConfirmed(true);
    } catch (error) {
      console.error("Error capturado en handleConfirm:", error);
      alert("Ocurrió un error al confirmar tu invitación. Intenta más tarde");
    } finally {
      setLoading(false);
    }
  };

  if (!guest) return null;

  const isMultiple = guest.invited > 1;

  return (
    <>
      {loading && <SpinnerOverlay />}
      <Dialog.Overlay className="dialog-overlay" />
      <Dialog.Content className="dialog-content">
        <Dialog.Title>
          <p className="confirmation-title-top">
            Queremos compartir este momento con ustedes
          </p>
        </Dialog.Title>
        {confirmed ? (
          <div className="confirmation-thankyou">
            <p className="confirmation-title-top">¡Gracias por confirmar!</p>
            <p className="confirmation-name">{guest.name}</p>
            <p className="confirmation-message">
              Confirmaste{" "}
              {selected === 0
                ? "que no asistirás"
                : `para ${selected} persona(s)`}
              .
            </p>
          </div>
        ) : (
          <>
            {/* Título */}
            {/* <p className="confirmation-title-top">
              Queremos compartir este momento con ustedes
            </p> */}

            <div className="confirmation-info">
              <p className="confirmation-name">{guest.name}</p>
              <p className="confirmation-passes">
                Pases:{" "}
                <span style={{ fontFamily: "serif" }}>{guest.invited}</span>
              </p>
            </div>

            {/* Radios */}
            <div className="confirmation-options">
              {isMultiple ? (
                <>
                  <label className="confirmation-option">
                    <input
                      type="radio"
                      name="confirmation"
                      value={guest.invited}
                      onChange={() => setSelected(guest.invited)}
                    />
                    <span>Sí, asistiremos</span>
                  </label>
                  <label className="confirmation-option">
                    <input
                      type="radio"
                      name="confirmation"
                      value={1}
                      onChange={() => setSelected(1)}
                    />
                    <span>Sólo yo</span>
                  </label>
                  <label className="confirmation-option">
                    <input
                      type="radio"
                      name="confirmation"
                      value={0}
                      onChange={() => setSelected(0)}
                    />
                    <span>Lo siento, no asistiremos</span>
                  </label>
                </>
              ) : (
                <>
                  <label className="confirmation-option">
                    <input
                      type="radio"
                      name="confirmation"
                      value={1}
                      onChange={() => setSelected(1)}
                    />
                    <span>Sí, asistiré</span>
                  </label>
                  <label className="confirmation-option">
                    <input
                      type="radio"
                      name="confirmation"
                      value={0}
                      onChange={() => setSelected(0)}
                    />
                    <span>Lo siento, no asistiré</span>
                  </label>
                </>
              )}
            </div>

            {/* Botón */}
            <button
              className="confirmation-button"
              onClick={handleConfirm}
              disabled={selected === null}
            >
              Confirmar
            </button>

            {/* Imagen con frase */}
            <div className="confirmation-image-wrapper">
              <img
                className="confirmation-image"
                src={modalImage}
                alt="Pareja confirmando"
              />
              <p className="confirmation-phrase">
                “Tu presencia es nuestro regalo más preciado,
                <br />
                por eso la invitación es personal e intransferible.”
              </p>
            </div>
          </>
        )}
      </Dialog.Content>
    </>
  );
};
